<template>
    <div class="mobParentalCon">
        <div class="costContainer" v-loading="loading">
            <!-- <div class="header">
                <i @click="back" class="el-icon-arrow-left"></i>
                <span>上传身份证</span>
            </div> -->

            <div class="content">
                <h2 class="section-title">个人信息核对</h2>

                <div class="info-group">
                    <div class="info-item">
                        <label>姓名</label>
                        <span class="value">{{ formData.title }}</span>
                    </div>
                    <div class="info-item">
                        <label>工号</label>
                        <span class="value">{{ formData.empNo }}</span>
                    </div>
                    <div class="info-item">
                        <label>当前证件有效期</label>
                        <span class="value">{{ formData.idenddate }}</span>
                    </div>
                </div>

                <div class="tips-box">
                    <i class="el-icon-info"></i>
                    <p>户籍地址/家庭住址：请确保地址填写完整，需精确到门牌号/具体房号</p>
                </div>

                <el-form ref="form" :rules="rules" :model="formData" label-position="left" label-width="120px"
                    class="custom-form">
                    <el-form-item label="证件签发机关" prop="idaddress">
                        <el-input v-model="formData.idaddress" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="籍贯" prop="nativePlace">
                        <el-input v-model="formData.nativePlace" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="户籍" prop="householdRegister" required>
                        <el-radio-group v-model="formData.householdRegister" class="right-radio-group">
                            <el-radio label="1246">农村</el-radio>
                            <el-radio label="1247">城镇</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="户籍地址" prop="permanentAddress">
                        <el-input v-model="formData.permanentAddress" type="textarea" autosize
                            class="no-padding-textarea" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="家庭住址" prop="liveAddress">
                        <el-input class="no-padding-textarea" v-model="formData.liveAddress" type="textarea" autosize
                            placeholder="请输入"></el-input>
                    </el-form-item>

                    <el-form-item label="新证件有效期开始时间" prop="idStartDate">
                        <el-date-picker v-model="formData.idStartDate" type="date" placeholder="请选择"
                            range-separator="—" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                            style="width: 100%"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="新证件有效期结束时间" prop="idenddate">
                        <el-date-picker v-model="formData.idenddate" type="date" placeholder="请选择"
                            range-separator="—" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                            style="width: 100%"></el-date-picker>
                    </el-form-item>

                </el-form>

                <div class="tips-box">
                    <i class="el-icon-info"></i>
                    <p>请上传清晰的身份证正反面照片，确保信息完整可见，无遮挡、无反光</p>
                </div>

                <div class="upload-section">

                    <div @click="onUploadClick('front')" class="upload-item">
                        <div class="label"><i class="el-icon-picture-outline"></i> 身份证正面 <span class="required">*</span>
                        </div>

                        <template v-if="!previews.front">


                            <div class="upload-card">
                                <i class="el-icon-camera"></i>
                                <p>点击拍摄或从相册选择</p>
                                <span>请拍摄身份证有头像的一面</span>
                            </div>
                        </template>
                        <img v-else :src="previews.front" class="preview-img" />
                    </div>

                    <div @click="onUploadClick('back')" class="upload-item">
                        <!-- <div class="label"><i class="el-icon-bank-card"></i> 身份证反面 <span class="required">*</span></div>
                        <div class="upload-card">
                            <i class="el-icon-camera"></i>
                            <p>点击拍摄或从相册选择</p>
                            <span>请拍摄身份证有国徽的一面</span>
                        </div> -->
                        <div class="label"><i class="el-icon-bank-card"></i> 身份证反面 <span class="required">*</span>
                        </div>

                        <template v-if="!previews.back">


                            <div class="upload-card">
                                <i class="el-icon-camera"></i>
                                <p>点击拍摄或从相册选择</p>
                                <span>请拍摄身份证有国徽的一面</span>
                            </div>
                        </template>
                        <img v-else :src="previews.back" class="preview-img" />

                    </div>
                </div>

                <div v-if="isReady" class="footer-btn">
                    <!-- <el-button type="primary">ddd</el-button> -->
                    <el-button @click="submitForm" :disabled="!isReady" type="primary"
                        class="submit-btn">确认上传</el-button>
                </div>

            </div>
        </div>


    </div>
</template>

<script>
// import apis from "@/apis/insurance.js";
import api from "@/apis";
import moment from "moment";
import apiMedal from "@/apis/medal";
import "moment/locale/zh-cn";
import { getToken } from "@/utils/cookie";

import { showLoading, hideLoading } from '@/utils/loading';

export default {
    name: "idcardEditPage",
    data() {
        const validateEndDate = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请选择截止日期'));
            }

            // 逻辑 1: 必须大于今天
            const today = new Date().setHours(0, 0, 0, 0);
            const end = new Date(value).getTime();
            if (end <= today) {
                return callback(new Error('截止日期必须大于今天（已过期）'));
            }

            // 逻辑 2: 必须大于起始日期
            if (this.formData.idStartDate) {
                const start = new Date(this.formData.idStartDate).getTime();
                if (end <= start) {
                    return callback(new Error('截止日期必须晚于起始日期'));
                }
            }

            callback(); // 校验通过
        };

        return {
            id: '', // service id.
            hideUpload: false,
            previews: {
                front: '', // 正面预览图
                back: ''   // 反面预览图
            },
            uploadPrefix: "",
            formData: {
                "id": "",
                "empID": "",
                "title": "",
                "empNo": "",
                "orgPath": "",
                "permanentAddress": "",
                "householdRegister": "",
                "idaddress": "",
                "orgID": "",
                "orgLineTitle": "",
                "nativePlace": "",
                "liveAddress": "",
                "idenddate": "",
                "idStartDate": null,
                "frontUrl": null,
                "backUrl": null
            },
            rules: {
                title: [
                    { required: true, message: '姓名不能为空', trigger: 'blur' }
                ],
                permanentAddress: [
                    { required: true, message: '请确保地址填写完整，需精确到门牌号/具体房号', trigger: 'blur' }
                ],
                householdRegister: [
                    { required: true, message: '请选择户口性质', trigger: 'change' }
                ],
                idaddress: [
                    { required: true, message: '请输入证件签发机关', trigger: 'blur' }
                ],
                nativePlace: [
                    { required: true, message: '请输入籍贯', trigger: 'blur' }
                ],
                liveAddress: [
                    { required: true, message: '请确保地址填写完整，需精确到门牌号/具体房号', trigger: 'blur' }
                ],
                idStartDate: [
                    { required: true, message: '请选择起始日期', trigger: 'change' },
                    // 当起始日期变化时，触发截止日期的重新校验，防止先选截止再选起始导致的逻辑错误
                    {
                        validator: (rule, value, callback) => {
                            if (value && this.formData.idenddate) {
                                this.$refs.form.validateField('idenddate');
                            }
                            callback();
                        }, trigger: 'change'
                    }
                ],
                idenddate: [
                    { required: true, validator: validateEndDate, trigger: 'change' }
                ],
                frontUrl: [
                    { required: true, message: '请上传身份证人像面', trigger: 'change' }
                ],
                backUrl: [
                    { required: true, message: '请上传身份证国徽面', trigger: 'change' }
                ]
            },
            isReady: true,
            labelPosition: 'top',
            fileList: [],
            loading: false,
        };
    },
    mounted() {
        this.uploadPrefix = `http://qw.nvc-lighting.com.cn:8088/hrApi`;
        // 获取 id
        const id = this.$route.query.id;

        console.log('当前业务ID:', id); // 输出: 1111

        if (id) {
            this.id = id;
            this.loadUserInfo();
        }
        const empNo = getToken();
        console.log('user token, ', empNo);
    },
    created() {

    },
    methods: {
        back() {
            this.$router.push('/mobile/home');
        },
        async loadUserInfo() {
            const self = this;
            const resp = await api.getUserIcCardInfo(self.id)
            const { data } = resp;
            self.formData = data;
            console.log('r, ', resp);
            if (data.state === 100010100010) {
                self.isReady = true;
            } else {
                self.isReady = false;
            }

            const frontUrl = this.formData.frontUrl;
            const backUrl = this.formData.backUrl;
            if (frontUrl) {
                self.previews.front = self.uploadPrefix + frontUrl;
            }
            if (backUrl) {
                self.previews.back = self.uploadPrefix + backUrl;
            }
        },
        // 处理点击上传
        onUploadClick(type) {
            if (!this.isReady) {
                return;
            }
            const input = document.createElement('input');
            input.type = 'file';
            // 允许图片类型，这样系统会自动弹出“拍照”和“相册”
            input.accept = 'image/*';

            input.onchange = (event) => {
                const file = event.target.files[0];
                if (file) {
                    this.processFile(file, type);
                }

            };
            input.click();
        },

        processFile(file, type) {
            // 1. 预览：使用 URL.createObjectURL 或 FileReader
            const reader = new FileReader();
            reader.onload = (e) => {
                // type 是 'front' 或 'back'
                this.previews[type] = e.target.result;
            };
            reader.readAsDataURL(file);

            // 2. 上传：提交给后端
            this.uploadFile(file, type);
        },
        async uploadFile(file, type) {
            // 1. 校验文件类型（可选，比如只允许图片）
            console.log('file, ', file)
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJPG) {
                this.$message.error('上传图片只能是 JPG/PNG 格式!');
                return false;
            }

            // 2. 准备提交数据
            const formData = new FormData();
            formData.append('file', file); // 注意：Element UI 的 file 对象通常在 file.raw 中


            // 开启全屏或局部 Loading
            showLoading('正在上传证件...');

            try {
                // 3. 发起请求
                const res = await apiMedal.getUpload(formData);
                console.log('upload res, ', res)

                if (res && res.id) {
                    const fileId = res.id;
                    const fileUrl = `/file/view/${fileId}`; // 匹配你之前的字段注释

                    // 5. 根据类型（正面/反面）赋值给 VO 字段
                    if (type === 'front') {
                        this.formData.frontUrl = fileUrl;
                    } else if (type === 'back') {
                        this.formData.backUrl = fileUrl;
                    }

                    this.$message.success('上传成功');
                } else {
                    this.$message.error(res.message || '上传失败');
                }
            } catch (error) {
                console.error('上传异常:', error);
                this.$message.error('服务器连接失败，请稍后重试');
            } finally {
                hideLoading()
            }
        },

        uploadToServer(file, side) {
            const formData = new FormData();
            formData.append('file', file);
            // axios.post('/api/upload', formData)...
            console.log('正在上传', side, file);
        },
        handlePreview(file) {
            console.log(file);
        },
        // 表单提交
        submitForm() {
            const self = this;
            this.$refs.form.validate((valid) => {
                if (valid) {
                    console.log("提交的身份证信息:", this.formData);

                    if (!this.formData.frontUrl || !this.formData.backUrl) {
                        this.$message.error('请上传身份证');
                        return
                    }
                    self.isReady = false;
                    api.submitIcCardInfo(self.formData).then(r => {
                        console.log('sub r, ', r);
                        if (r.code === 200) {
                            self.$message.success('提交成功');
                            self.loadUserInfo();
                        }

                    })


                } else {
                    console.log("表单验证失败");
                    self.$message.error('您的信息填写异常，根据页面提示，请检查填写信息');
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
    .costContainer {
        width: 100%;
    }
}

@media screen and (min-width: 600px) {
    .costContainer {
        width: 276px * $zoom;
    }
}

.mobParentalCon {
    width: 100%;
    display: flex;
    justify-content: center;
    height: 100vh;
}


.header {
    height: 75px;
    background: #fff;
    display: flex;
    align-items: center;
    padding: 15px 15px;
    font-size: 38px;
    border-bottom: 1px solid #eee;

    i {
        margin-right: 10px;
        font-weight: bold;
    }
}

.content {

    .no-padding-textarea {
        ::v-deep .el-textarea__inner {
            padding: 0; // 去掉内边距
            border: none; // 这种场景通常也会去掉边框（根据你之前的截图需求）
            resize: none; // 移动端通常也会去掉右下角的拉伸图标
        }
    }

    padding: 15px;

    .section-title {
        font-size: 26px;
        margin-bottom: 20px;
        color: #333;
        font-weight: bold;
    }

    // 只读信息展示
    .info-group {
        background: #fff;
        padding: 10px 0;
        margin-bottom: 15px;
        border: 1px solid #eee;
        border-radius: 10px;
        margin: 20px 0px;

        .info-item {
            display: flex;
            justify-content: space-between;
            padding: 12px 0;
            margin: 0 15px;
            border-bottom: 1px solid #f5f5f5;

            font-size: 30px;

            label {
                color: #333;
                font-weight: 500;
            }

            .value {
                color: #666;
            }

            &:last-child {
                border-bottom: none;
            }
        }
    }

    // 表单覆盖样式
    .custom-form {
        background: #fff;
        padding: 0 15px;
        margin: 25px auto;

        .right-radio-group {
            width: 100%;
            display: flex;
            justify-content: flex-end; // 使单选组整体靠右对齐
            align-items: center;
            height: 40px; // 与 input 高度保持一致

            ::v-deep .el-radio {
                margin-right: 0;
                margin-left: 20px;
                display: flex;
                align-items: center;

                .el-radio__label {
                    font-size: 30px;
                    padding-left: 6px;
                }

                // .el-radio__inner {
                //     // width: 16px;
                //     // height: 16px;
                // }
            }
        }

        ::v-deep .el-form-item {
            border-bottom: 1px solid #f5f5f5;
            margin-bottom: 50px;
            padding: 5px 0;

            .el-form-item__label {
                color: #333;
                font-weight: bold;
                font-size: 28px;
            }

            .el-input__inner {
                border: none;
                text-align: right;
                padding-right: 0;
                font-size: 30px;
            }

            .el-textarea__inner {
                border: none;
                text-align: right;
                resize: none;
                font-size: 30px;
            }

            .el-form-item__error {
                font-size: 26px;
            }
        }
    }

    // 蓝色提示框
    .tips-box {
        background-color: #ecf5ff;
        border: 1px solid #d9ecff;
        padding: 10px 15px;
        border-radius: 4px;
        display: flex;
        align-items: flex-start;
        margin: 20px 0;


        i {
            color: #409eff;
            margin-top: 3px;
            margin-right: 8px;

            font-size: 30px;
        }

        p {
            color: #409eff;
            font-size: 26px;
            line-height: 1.5;
            margin: 0;
        }
    }

    // 上传区域
    .upload-section {
        .upload-item {
            margin-bottom: 20px;

            position: relative;
            overflow: hidden; // 防止图片超出圆角

            .label {
                margin-bottom: 10px;
                font-weight: bold;
                font-size: 26px;

                i {
                    color: #409eff;
                    margin-right: 5px;
                }

                .required {
                    color: #f56c6c;
                }
            }

            .upload-card {
                height: 180px;
                background: #fff;
                border: 1px dashed #ccc;
                border-radius: 8px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                i {
                    font-size: 40px;
                    color: #999;
                    margin-bottom: 10px;
                }

                p {
                    margin: 5px 0;
                    color: #666;
                    font-size: 28px;
                }

                span {
                    color: #bbb;
                    font-size: 20px;
                }
            }



            .preview-img {
                width: 100%;
                height: 300px;
                object-fit: fill; // 保持比例填充
            }

        }
    }

    .footer-btn {
        margin-top: 30px;

        .submit-btn {
            width: 100%;
            height: 66px;
            font-size: 26px;
            border-radius: 8px;
            background: #66b1ff;
            // background-color: #dcdfe6;
            border: none;
        }
    }

}
</style>
